<div class="dialog-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="dialog-content results-dialog" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h3>Validation Results</h3>
      <button class="btn-close" (click)="onClose()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
    
    <div class="dialog-body">
      <div class="results-summary">
        <div class="summary-card">
          <span class="summary-label">Total Files</span>
          <span class="summary-value">{{ results.length }}</span>
        </div>
        <div class="summary-card success">
          <span class="summary-label">Passed</span>
          <span class="summary-value">{{ getPassedCount() }}</span>
        </div>
        <div class="summary-card error">
          <span class="summary-label">Flagged</span>
          <span class="summary-value">{{ getFlaggedCount() }}</span>
        </div>
      </div>

      <div class="results-table-dialog">
        <div class="results-row results-header">
          <span class="col-filename">Filename</span>
          <span class="col-api">API</span>
          <span class="col-coordinate">Survey BH x</span>
          <span class="col-coordinate">Survey BH y</span>
          <span class="col-coordinate">IHS BH x</span>
          <span class="col-coordinate">IHS BH y</span>
          <span class="col-distance">Distance (ft)</span>
          <span class="col-flag">Flag</span>
          <span class="col-error">Error</span>
        </div>
        <div class="results-row" *ngFor="let result of results" 
             [class.row-error]="result.error" 
             [class.row-flagged]="result.flag">
          <span class="col-filename" [title]="result.filename">{{ result.filename }}</span>
          <span class="col-api">{{ result.api || '-' }}</span>
          <span class="col-coordinate">
            {{ result.calculated_bh_x !== undefined && result.calculated_bh_x !== null ? (result.calculated_bh_x | number:'1.2-2') : '-' }}
          </span>
          <span class="col-coordinate">
            {{ result.calculated_bh_y !== undefined && result.calculated_bh_y !== null ? (result.calculated_bh_y | number:'1.2-2') : '-' }}
          </span>
          <span class="col-coordinate">
            {{ result.reference_bh_x !== undefined && result.reference_bh_x !== null ? (result.reference_bh_x | number:'1.2-2') : '-' }}
          </span>
          <span class="col-coordinate">
            {{ result.reference_bh_y !== undefined && result.reference_bh_y !== null ? (result.reference_bh_y | number:'1.2-2') : '-' }}
          </span>
          <span class="col-distance">
            {{ result.distance !== undefined && result.distance !== null ? (result.distance | number:'1.2-2') : '-' }}
          </span>
          <span class="col-flag">
            <span class="flag-badge" [class.flag-yes]="result.flag" [class.flag-no]="result.flag === false">
              {{ result.flag === true ? 'Yes' : (result.flag === false ? 'No' : '-') }}
            </span>
          </span>
          <span class="col-error" [title]="result.error || ''">
            {{ result.error || '-' }}
          </span>
        </div>
      </div>
    </div>
    
    <div class="dialog-footer">
      <button class="btn-download" (click)="downloadResults()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
        Download Results
      </button>
      <button class="btn-secondary" (click)="onClose()">Close</button>
      <button class="btn-primary" (click)="onClearAll()">Clear & Start New</button>
    </div>
  </div>
</div>
